import React, { useEffect, useState } from 'react';
import { useTheme } from '@mui/material/styles';
import HomeIcon from '@mui/icons-material/Home';
import { dataStats } from '../data/data_stats';
import { Box, Paper, Typography, CircularProgress } from '@mui/material';

function AppHome() {
    const theme = useTheme();
    const [stats, setStats] = useState({
        latestTickets: '',
        latestCommits: '',
        rendersLast7Days: 0
    });
    const [loading, setLoading] = useState(true);

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleDateString('en-US', {
            month: 'short',
            day: 'numeric',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    useEffect(() => {
        dataStats.loadUserStats().then(data => {
            const latestTickets = formatDate(data.tickets[0].latest_date);
            const latestCommits = formatDate(data.commits[0].latest_date);
            const rendersLast7Days = parseInt(data.renders[0].total_renders, 10);
            setStats({
                latestTickets,
                latestCommits,
                rendersLast7Days
            });
            setLoading(false);
        });
    }, []);

    if (loading) {
        return (
            <Box display="flex" justifyContent="center" alignItems="center" height="100vh">
                <CircularProgress />
            </Box>
        );
    }

    return (
        <Box textAlign="center" mt={10}>
            <HomeIcon style={{ fontSize: '64px', color: theme.palette.text.secondary }} />
            <Typography variant="h6" style={{ color: theme.palette.text.secondary, marginBottom: '40px' }}>
                DevSight Home Dashboard
            </Typography>
            <Box display="flex" justifyContent="center" gap={2}>
                {[
                    { title: "Latest Jira Tickets", count: stats.latestTickets },
                    { title: "Latest Commit Data", count: stats.latestCommits },
                    { title: "Total Chart Renders (7 Days)", count: stats.rendersLast7Days }
                ].map((metric, index) => (
                    <Paper key={index} elevation={3} style={{ padding: '20px', width: '220px', height: '220px', display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'center' }}>
                        <Typography variant="subtitle1" color="textSecondary" style={{ fontSize: '1.2rem' }}>
                            {metric.title}
                        </Typography>
                        <Typography variant="h6" style={{ marginTop: '10px', fontSize: '1.4rem', whiteSpace: 'pre-line', color: theme.palette.primary.main, lineHeight: 1.2 }}>
                            {typeof metric.count === 'string' && (metric.count.includes('AM') || metric.count.includes('PM'))
                                ? metric.count.replace(/, (\d{2}:\d{2})/, '\n$1')
                                : metric.count}
                        </Typography>
                    </Paper>
                ))}
            </Box>
        </Box>
    );
}

export default AppHome;